import { getIntDate } from '@/views/analysis/common.js'
export default {
  titleTxt: [
    {
      title: '评论分布',
      tipTxt: '在选定的查询条件以及时间周期内，您可以了解正面评价、负面评价、中性评价、问题咨询等不同类型评论各有多少，比例多大。'
    },
    {
      title: '评论趋势',
      tipTxt: '您可以了解正面评价、负面评价、中性评价、问题咨询等不同类型评论量的变化趋势。'
    },
    {
      title: '评论关注点',
      tipTxt: '在选定的查询条件以及时间周期内，您可以了解正面评价、负面评价、问题咨询等不同类型评论所涉及的具体关注点分布情况。'
    },
    {
      title: '评论明细',
      tipTxt: '在点击左侧某个评论关注点，您可以了解关于该评论关注点的具体评论信息。'
    },
    {
      title: '评论明细',
      tipTxt: '通过将多个维度组合汇总统计，您可以更好地发现其中的数据规律。'
    }
  ],
  filterAjaxList: [
    {
      url: '/api/label/brand/label',
      method: 'post',
      param: {},
      flagKey: 'brand',
      id: 'name',
      name: 'name'
    },
    {
      url: '/api/label/line/label',
      method: 'get',
      flagKey: 'lineName',
      id: 'name',
      name: 'name'
    },
    {
      url: '/api/label/platform/label',
      method: 'post',
      param: {},
      flagKey: 'platform',
      id: 'name',
      name: 'name'
    },
    {
      url: '/api/label/is/prereport/label',
      method: 'get',
      flagKey: 'isPrereport',
      id: 'name',
      name: 'name'
    }
  ],
  filterForm: [
    {
      type: 'select',
      clearable: true,
      id: 'platform',
      label: '平台',
      width: '200px',
      intintValue: '',
      children: []
    }, {
      type: 'select',
      clearable: true,
      id: 'brand',
      label: '品牌',
      width: '200px',
      intValue: '',
      children: []
    }, {
      type: 'select',
      clearable: true,
      id: 'lineName',
      label: '产线',
      placeholder: '综合',
      width: '200px',
      intintValue: '',
      children: []
    },
    {
      type: 'select',
      id: 'isPrereport',
      label: '是否报备',
      placeholder: '全部',
      width: '200px',
      intintValue: '',
      children: []
    },
    {
      type: 'tab',
      id: 'timeType',
      label: '选择时间',
      intValue: '0',
      children: [{
        id: '0',
        name: '月报',
        showItemId: 'dateMonth',
        hideItemId: 'dateTime'
      }, {
        id: '1',
        name: '日报',
        showItemId: 'dateTime',
        hideItemId: 'dateMonth'
      }]
    }, {
      type: 'month',
      isHide: false,
      format: 'yyyy年 MM月',
      valueFormat: 'yyyy-MM',
      clearable: true,
      id: 'dateMonth',
      label: '',
      width: '160px',
      // intValue: '2021-12'
      intValue: getIntDate()
    }, {
      type: 'datesRange',
      dateType: 'date',
      isHide: true,
      clearable: true,
      id: 'dateTime',
      startTimeId: 'dateTimeStartTime',
      endTimeId: 'dateTimeEndTime',
      label: '',
      width: '390px',
      intValue: ['', '']
    }
  ],
  formRules: {
    brand: [
      {
        required: true,
        message: '请选择'
      }
    ]
  },
  distributeList: [
    {
      name: '正面',
      sumKey: '',
      sum: '33355',
      color: '#FFC750'
    },
    {
      name: '负面',
      sumKey: '',
      sum: '70143',
      color: '#326CFA'
    },
    {
      name: '中性',
      sumKey: '',
      sum: '11433',
      color: '#DEE3E5'
    }
  ],
  seriesData: [
    {
      name: '正面评价',
      type: 'line',
      data: [],
      itemColor: '#FFC750',
      key: 'front'
    }, {
      name: '负面评价',
      type: 'line',
      data: [],
      itemColor: '#326CFA',
      key: 'negative'
    }, {
      name: '中性评价',
      type: 'line',
      data: [],
      itemColor: '#DEE3E5',
      key: 'neutral'
    }
  ],
  trendList: [],
  tabList: [
    {
      id: '正面评价',
      name: '正面评价'
    }, {
      id: '负面评价',
      name: '负面评价'
    }, {
      id: '问题咨询',
      name: '问题咨询'
    }
  ],
  focusPointLists: [
    {
      name: '外观漂亮',
      sum: '12',
      color: 'rgba(255, 199, 88, 1)',
      circleRadius: '164px',
      fontSize: '16px',
      top: '14%', // 以 300高度为基准
      left: '2%' // 以 600宽度为基准
    }, {
      name: '风大马力大',
      sum: '6',
      color: 'rgba(255, 199, 88, 0.8)',
      circleRadius: '134px',
      fontSize: '14px',
      top: '39%',
      left: '39%'
    }, {
      name: '安装服务好',
      sum: '5',
      color: '#326CFA',
      circleRadius: '100px',
      fontSize: '12px',
      top: '8%',
      left: '32%'
    }, {
      name: '操作便捷',
      sum: '3',
      color: 'rgba(255, 199, 88, 0.6)',
      circleRadius: '92px',
      fontSize: '12px',
      top: '1%',
      left: '64%'
    }, {
      name: '没有杂音',
      sum: '1',
      color: '#A7C1FF',
      circleRadius: '70px',
      fontSize: '12px',
      top: '33%',
      left: '62%'
    }, {
      name: '口碑好',
      sum: '1',
      color: '#CEDCFF',
      circleRadius: '50px',
      fontSize: '12px',
      top: '69%',
      left: '69%'
    }
  ],
  detailList: [
    {
      dateTime: '2021/9/2  17:59',
      type: '安装服务好',
      content: '简单几步实现冰皮月饼自由简单几步实现冰皮月饼自由简单几步实现冰皮月饼自由简单几步实现冰皮月饼自由简单几步实现冰皮月饼自由简单几步实现冰皮月饼自由',
      author: '小镇上的猪精女孩'
    }, {
      dateTime: '2021/9/2  17:59',
      type: '外观漂亮',
      content: '简单几步实现冰皮月饼自由简单几步实现冰皮月饼自由简单几步实现冰皮月饼自由简单几步实现冰皮月饼自由简单几步实现冰皮月饼自由简单几步实现冰皮月饼自由',
      author: '小镇上的猪精女孩'
    }, {
      dateTime: '2021/9/2  17:59',
      type: '口碑好',
      content: '简单几步实现冰皮月饼自由',
      author: '小镇上的猪精女孩'
    }, {
      dateTime: '2021/9/2  17:59',
      type: '没有杂音',
      content: '简单几步实现冰皮月饼自由',
      author: '小镇上的猪精女孩'
    }, {
      dateTime: '2021/9/2  17:59',
      type: '操作便捷',
      content: '简单几步实现冰皮月饼自由',
      author: '小镇上的猪精女孩'
    }
  ],
  crossAjaxList: [
    {
      url: '/api/label/overlapping/label',
      method: 'post',
      param: {
        type: 1
      },
      flagKey: 'col1Id',
      id: 'id',
      name: 'indexName'
    },
    {
      url: '/api/label/overlapping/label',
      method: 'post',
      param: {
        type: 2
      },
      flagKey: 'row1Id',
      id: 'id',
      name: 'indexName'
    }
  ],
  crossFilter: [
    {
      type: 'select',
      id: 'row1Id',
      labelName: 'row1Label',
      indexName: 'row1Name',
      typeName: 'row1Type',
      label: '行',
      width: '250px',
      intValue: '',
      children: []
    },
    {
      type: 'select',
      id: 'row2Id',
      labelName: 'row2Label',
      indexName: 'row2Name',
      typeName: 'row2Type',
      width: '170px',
      intValue: '',
      children: []
    },
    {
      type: 'select',
      id: 'col1Id',
      labelName: 'col1Label',
      indexName: 'col1Name',
      typeName: 'col1Type',
      label: '列',
      width: '250px',
      intValue: '',
      children: []
    },
    {
      type: 'select',
      id: 'col2Id',
      labelName: 'col2Label',
      indexName: 'col2Name',
      typeName: 'col2Type',
      width: '170px',
      intValue: '',
      children: []
    }, {
      type: 'radio',
      clearable: true,
      id: 'type',
      label: '指标',
      width: '300px',
      intValue: '1',
      children: [
        {
          id: '1',
          name: '内容数'
        },
        {
          id: '2',
          name: '评论数'
        }
      ]
    }
  ]
}
